import { render, staticRenderFns } from "./ContractDocumentContainer.vue?vue&type=template&id=54eb243c&scoped=true"
import script from "./ContractDocumentContainer.vue?vue&type=script&lang=js"
export * from "./ContractDocumentContainer.vue?vue&type=script&lang=js"
import style0 from "./ContractDocumentContainer.vue?vue&type=style&index=0&id=54eb243c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb243c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54eb243c')) {
      api.createRecord('54eb243c', component.options)
    } else {
      api.reload('54eb243c', component.options)
    }
    module.hot.accept("./ContractDocumentContainer.vue?vue&type=template&id=54eb243c&scoped=true", function () {
      api.rerender('54eb243c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/ContractDocumentContainer.vue"
export default component.exports